import { render, staticRenderFns } from "./SearchRecipient.vue?vue&type=template&id=1d868348"
import script from "./SearchRecipient.vue?vue&type=script&lang=js"
export * from "./SearchRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports